import { createSlice } from "@reduxjs/toolkit";
import { ExternalContractType, WorkPackagesType } from "./Types";

type initialstateType = {
    fetchedExternalContractsPartnerID: number;
    externalContracts: ExternalContractType[];
    externalContractDetails: ExternalContractType | null;
    workPackages: WorkPackagesType[];
    typeOfEngagements: {
        value: string;
    }[];
    status: {
        externalContractLoading: boolean;
        addExternalContractLoading: boolean;
        addExternalContractStatus: boolean;
        updateExternalContractLoading: boolean;
        updateExternalContractStatus: boolean;
        deleteExternalContractLoading: boolean;
        deleteExternalContractStatus: boolean;
        typeOfEngagementsLoading: boolean;
    };
}

var initialState: initialstateType = {
    fetchedExternalContractsPartnerID: 0,
    externalContracts: [],
    externalContractDetails: null,
    workPackages: [],
    typeOfEngagements: [],
    status: {
        externalContractLoading: false,
        addExternalContractLoading: false,
        addExternalContractStatus: false,
        updateExternalContractLoading: false,
        updateExternalContractStatus: false,
        deleteExternalContractLoading: false,
        deleteExternalContractStatus: false,
        typeOfEngagementsLoading: false
    }
};

const externalContractSlice = createSlice({
    name : "external-contract",
    initialState : initialState,
    reducers : {
        setFetchedExternalContractsPartnerID: (state, action) => {
            state.fetchedExternalContractsPartnerID = action.payload; 
        },
        setExternalContracts: (state, action) => {
            state.externalContracts = action.payload; 
        },
        setExternalContractDetails: (state, action) => {
            state.externalContractDetails = action.payload; 
        },
        setExternalContractLoading: (state, action) => {
            state.status.externalContractLoading = action.payload; 
        },
        setAddExternalContractLoading: (state, action) => {
            state.status.addExternalContractLoading = action.payload; 
        },
        setAddExternalContractStatus: (state, action) => {
            state.status.addExternalContractStatus = action.payload; 
        },
        setUpdateExternalContractLoading: (state, action) => {
            state.status.updateExternalContractLoading = action.payload; 
        },
        setUpdateExternalContractStatus: (state, action) => {
            state.status.updateExternalContractStatus = action.payload; 
        },
        setDeleteExternalContractLoading: (state, action) => {
            state.status.deleteExternalContractLoading = action.payload; 
        },
        setDeleteExternalContractStatus: (state, action) => {
            state.status.deleteExternalContractStatus = action.payload; 
        },
        setWorkPackages: (state, action) => {
            state.workPackages = action.payload;
        },
        setTypeOfEngagements: (state, action) => {
            state.typeOfEngagements = action.payload;
        },
        setTypeOfEngagementsLoading: (state, action) => {
            state.status.typeOfEngagementsLoading = action.payload;
        }
    }
})

export const externalContractSliceReducer = externalContractSlice.reducer;
export const externalContractSliceAction = externalContractSlice.actions;